import type { CaseDefinition } from "../domain/types/index.js";
import type { StoredStage } from "../features/stageMaker/stageRecord.js";
import type { StageDefinition } from "./stages.js";

const stages = new Map<string, StageDefinition>();
const cases = new Map<string, CaseDefinition>();
const records = new Map<string, StoredStage>();

export function registerCustomStage(
  stage: StageDefinition,
  stageCases: readonly CaseDefinition[],
  record?: StoredStage,
): void {
  stages.set(stage.id, stage);
  for (const item of stageCases) cases.set(item.id, item);
  if (record) records.set(stage.id, record);
}

export function getRegisteredStage(id: string | undefined): StageDefinition | undefined {
  return id ? stages.get(id) : undefined;
}

export function getRegisteredCase(id: string): CaseDefinition | undefined {
  return cases.get(id);
}

export function getRegisteredStageRecord(id: string | undefined): StoredStage | undefined {
  return id ? records.get(id) : undefined;
}

export function clearCustomRegistry(): void {
  stages.clear();
  cases.clear();
  records.clear();
}
